import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { RefundStatus } from './refund.status.enum';

// Define RefundStatus as an enum or union
const RefundStatusSchema = EnumSchema(RefundStatus);
// Define all relevant statuses
const statusDescriptions: Record<RefundStatus, string> = {
    pending: 'The date when the refund status was pending.',
    initiated: 'The date when the refund status was initiated.',
    succeeded: 'The date when the refund status was succeeded.',
    failed: 'The date when the refund status was failed.',
};

// Define the schema for the response
const StatusDatesSchema = z
    .record(RefundStatusSchema, z.date().openapi({ format: 'date-time', type: 'string', description: 'Status timestamp' }))
    .openapi({
        type: 'object',
        properties: {
            pending: { type: 'string', format: 'date-time', description: statusDescriptions.pending },
            initiated: { type: 'string', format: 'date-time', description: statusDescriptions.initiated },
            succeeded: { type: 'string', format: 'date-time', description: statusDescriptions.succeeded },
            failed: { type: 'string', format: 'date-time', description: statusDescriptions.failed },
        },
        additionalProperties: false,
    });

// Create a Zod DTO for Swagger/OpenAPI
export class StatusDatesDto extends FromSchema(StatusDatesSchema) {}
